import { createContext, useContext, useEffect, useState, useCallback } from 'react';

const ModalContext = createContext(null);

// Conta quantos modais de cadastro estão abertos no momento — o auto-refresh
// do Layout (useAutoRefresh) consulta isso pra não recarregar a página e
// derrubar um formulário que o usuário está preenchendo.
export function ModalProvider({ children }) {
  const [contagem, setContagem] = useState(0);
  const alterar = useCallback(delta => setContagem(c => c + delta), []);
  return (
    <ModalContext.Provider value={{ algumAberto: contagem > 0, alterar }}>
      {children}
    </ModalContext.Provider>
  );
}

export function useAlgumModalAberto() {
  return useContext(ModalContext)?.algumAberto ?? false;
}

// Chamado pelas páginas com o estado (booleano) do próprio modal de cadastro.
export function useModalAberto(aberto) {
  const ctx = useContext(ModalContext);
  useEffect(() => {
    if (!ctx || !aberto) return;
    ctx.alterar(1);
    return () => ctx.alterar(-1);
  }, [aberto, ctx]);
}
